<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "RIDP_SUCCESS_HEADER" | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body text-center">
    <img
      aria-hidden="true"
      class="col px-0"
      src="../../../assets/images/⚛️ Progress-Tracker.Icon - COMPLETE.svg"
      [alt]=""
    />
    <div class="pt-3 pb-2">
      <p class="mb-0">{{ "RIDP_SUCCESS_TEXT" | globalTranslate }}</p>
    </div>
    <div class="modal-footer justify-content-center">
      <div class="me-2 ml-2">
        @if (!isMobileUser) {
        <button
          type="button"
          id="dialog"
          class="btn d-grid btn-secondary"
          (click)="onContinue()"
        >
          {{ "CONTINUE_TCC" | globalTranslate }}
        </button>
        } @if (isMobileUser) {
        <p>{{ "MOBILE_IDVERIFY_TEXT_01" | globalTranslate }}</p>
        }
      </div>
    </div>
  </div>
</div>